import React from 'react';
import {Box} from '@mui/material';

import Home from './views/Home';

function App() {
  return (
    <Box sx={{background: '#454545'}}>
      <Home />
    </Box>
  );
}

export default App;
